import { getUniqueScoredWordCount } from '~/boggle/config/runSummaryScore'

import type { BoggleBadgeCheck } from '../checkTypes'
import { isRunEndEntry } from '../checkTypes'

export const masterCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  if (!isRunEndEntry(entry) || getUniqueScoredWordCount(entry.acceptedWords) < 40) {
    return false
  }
  const average = entry.sumAcceptedWordLengths / entry.acceptedWordCount
  return average >= 4.5
}
